<template>
  <div class="base-breadcrumb">
    <base-skeleton
      v-if="loading"
      no-background
      class="mb-3 mt-2 pt-1"
    >
      <div
        class="skeleton__item py-2"
        style="width: 180px;"
      />
    </base-skeleton>
    <base-text
      v-else
      light
      class="d-flex"
    >
      <template v-for="(item, index) in breadcrumbList">
        <template v-if="item.loading">
          <base-skeleton :key="'skeleton'+index">
            <span
              class="skeleton__item d-block"
              style="width: 70px;"
            />
          </base-skeleton>
          <span
            v-if="index < breadcrumbList.length - 1"
            :key="'separation'+index"
            class="separation"
          >></span>
        </template>
        <template v-else>
          <span :key="`breadcrumb-${ index }`">
            <span
              class="breadcrumb__item"
              :class="{
                'linked': !!item.link,
                'last': index == breadcrumbList.length - 1
              }"
              @click="onClick(item.link)"
            >{{ item.name | striphtml }}</span>
            <span
              v-if="index < breadcrumbList.length - 1"
              class="separation"
            >></span>
          </span>
        </template>
      </template>
    </base-text>
  </div>
</template>

<script>

export default {
  name: 'BaseBreadcrumb',
  props: {
    /**
     * @Example
     * [
        {
          name: 'Appointments',
          link: '/appointments',
        },
        {
          name: this.item.subject,
        },
      ]
     */
    routes: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      breadcrumbList: [],
    };
  },
  watch: {
    $route: {
      handler() {
        if (this.routes) {
          this.breadcrumbList = this.routes;
        } else if (this.$route) {
          this.breadcrumbList = this.$route.meta.breadcrumb;
        }
      },
      immediate: true,
    },
    routes() {
      this.breadcrumbList = this.routes;
    },
  },
  methods: {
    onClick(link) {
      if (!link) {
        return;
      }
      if (this.$route) {
        this.$router.push(link);
      } else {
        // eslint-disable-next-line
        console.log('No router');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.base-breadcrumb {
  margin-bottom: 8px;
  margin-top: 10px;
}
.breadcrumb__item{
  font-size: 14px;
}
.linked {
  cursor: pointer;
  border-bottom: solid 1px transparent;
  transition: border 0.2s;
  &:hover {
    // text-decoration: underline;
    border-bottom-color: #333;
  }
}
.last {
  font-family: $font-family-sans-serif-medium;
  border-bottom: solid 1px #333;
}
.separation {
  margin: 0 0.5rem;
}
</style>
